import Head from 'next/head';

export default function MarketingFonts() {
  return (
    <Head>
      <link
        rel="preload"
        href="/landing/assets/Geist-Regular.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        href="/landing/assets/Geist-SemiBold.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
    </Head>
  );
}
